module.exports = __webpack_public_path__ + "static/media/great-outline.a66037df.png";